<template>
  <div class="main width-100 height-100">
    <div v-if="error" class="preview-error width-100 height-100 justify-center align-items-center">
      <div class="direction-column justify-center align-items-center">
        <svg-icon class="error-icon flex-0-0-auto" icon="empty-default"></svg-icon>
        <div class="error-text">{{ errorMsg }}</div>
      </div>
    </div>
    <div v-if="isGenerating" class="preview-generating width-100 height-100 justify-center align-items-center">
      <genetating-status-view :percent="percent"></genetating-status-view>
    </div>
    <transition name="share-header">
      <div v-if="!loading" v-show="!headerHidden" class="wx-share-file-header width-100" v-on:click="toggleHeaderExpand">
        <div class="direction-column width-100">
          <div class="width-100 wx-share-file-header-content">
            <div v-show="headerExpand" class="direction-column width-100">
              <div class="direction-row width-100 align-items-center">
                <div class="item-img-big flex-0-0-auto">
                  <svg-icon class="flex-0-0-auto item-img-big" :icon="fileItem.type_icon" :cls="typeCls"></svg-icon>
                </div>
                <div class="direction-column width-0 flex-1-1-auto">
                  <div class="item-name ellipsis flex-1-1-auto">{{fileItem.name}}</div>
                  <div class="item-desc ellipsis flex-1-1-auto">{{fileItem.approx_size}}</div>
                </div>
                <a v-if="!isOwner" class="text-report flex-0-0-auto align-self-start" :href="complaintUrl">举报</a>
              </div>
              <div class="share-msg">{{shareProcess.description}}</div>
            </div>
            <div v-show="!headerExpand" class="direction-row align-items-center width-100 flex-1-1-auto justify-space-between">
              <div class="direction-row justify-start ellipsis width-0 align-items-center flex-1-1-auto">
                <svg-icon class="item-img-small flex-0-0-auto" :icon="fileItem.type_icon" :cls="typeCls"></svg-icon>
                <div class="flex-1-1-auto direction-row width-0 align-items-center">
                  <div class="item-name-small ellipsis">{{fileItem.name}}</div>
                  <!-- 这里添加svg图片 -->
                  <svg-icon class="svg-img flex-0-0-auto" icon="info"></svg-icon>
                </div>
              </div>
              <a v-if="!isOwner" class="text-report flex-0-0-auto align-self-start" :href="complaintUrl">举报</a>
            </div>
          </div>
          <div class="gap-line"></div>
        </div>
      </div>
    </transition>
    <div class="overlay width-100 height-100" v-show="headerExpand" v-on:click="toggleHeaderExpand"></div>
    <div class="preview-main width-100 height-100" v-if="!isGenerating && !error">
      <pdf-viewer
        v-if="viewer === 'pdf'"
        :previewInfo="previewInfo"
        :item="fileItem"
        @state-changed="handlePdfStateChanged"
        @onpageclick="toggleHeaderHidden"
      />
      <image-swipe
        v-else-if="viewer === 'image'"
        :item="fileItem"
        scenario="share"
        :previewInfo="previewInfo"
        :renderLimit="renderLimit"
        @state-change="handleChangeState"
        @image-tap="toggleHeaderHidden"
      />
      <wps-viewer
        v-else-if="viewer === 'wps'"
        @state-changed="handleWpsStateChanged"
        @onpageclick="toggleHeaderHidden"
        :previewInfo="previewInfo"
        :item="fileItem"
        :url="previewInfo.preview_url"
      />
      <div v-else-if="viewer === 'video'" class="width-100 height-100" style="background-color: #ffffff;">
        <div class="video-container">
          <video-viewer
            :previewInfo="previewInfo"
            :item="fileItem"
            @video-error="handleVideoError"
          />
        </div>
      </div>
      <div v-else-if="viewer === 'yiqixie'" class="width-100 height-100" style="background-color: #ffffff;">
        <div class="yqx-container">
          <yqx-viewer :item="fileItem" scenario="share"/>
        </div>
      </div>
    </div>
    <transition name="share-footer">
      <div v-show="isShareRoot && !loading && !headerHidden" class="preview-footer width-100 direction-column">
        <div class="gap-line"></div>
        <div class="preview-footer-content width-100 direction-row align-items-center">
          <div class="direction-row flex-1-1-auto">
            <div v-if="!saved" class="direction-row flex-1-1-auto align-items-center">
              <div class="footer-text flex-0-0-auto" v-on:click="view">查看我的文件</div>
              <svg-icon class="flex-0-0-auto" style="width: 14px; height: 14px;" icon="list_arrow"></svg-icon>
            </div>
            <div v-else class="direction-row flex-1-1-auto">
              <div class="footer-text flex-0-0-auto">已保存到亿方云共享网盘</div>
              <div bk id="onShareGotoDocumentClicked" class="btn-view flex-0-0-auto" v-on:click="view">查看</div>
            </div>
          </div>
          <van-button bk id="onShareSaveClicked" v-if="!saved && canSave && !isOwner" class="btn-save flex-0-1-auto" round v-on:click="save" :loading="saveLoading">保存</van-button>
          <van-button bk id="onShareGotoShareClicked" v-if="canShare" class="btn-share flex-0-1-auto" round v-on:click="share">分享</van-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import wxajax from '@/utils/wxajax'
import PdfViewer, {PdfState} from '../preview/PdfViewer'
import ImageSwipe from '../preview/ImageSwipe'
import ImageViewer from '../preview/ImageViewer'
import VideoViewer from '../preview/VCloudPlayerViewer'
import YqxViewer from '../preview/YqxViewer'
import WpsViewer, {WpsState} from '../preview/WpsViewer'
import GenetatingStatusView from './GeneratingStatusView'
import { normalizeFile } from '@/utils/fileUtils'
import { APPLET_SAVE_FILE_USER } from '@/config/applet-api'
import { FILE_INFO, GET_SHARE_LINK, SAVE_FILE } from '@/config/api'
import PreviewCore from '@/utils/PreviewCore'
import PreviewLog from '../../log/PreviewLog'
import config from '@/config'
import WxApi from '../../utils/WxApi.js'
import BLWxPreview from '@/bi/blWxPreview'
import PreviewTimer from '@/bi/previewTimer'
import track from '@/utils/eventTrack'

export default {
  name: 'WxSharePreviewView',
  components: {
    PdfViewer,
    ImageSwipe,
    ImageViewer,
    VideoViewer,
    YqxViewer,
    WpsViewer,
    GenetatingStatusView
  },
  computed: {
    complaintUrl () {
      return config.requestUrl + '/home/complaint?sharedata=' + `/share/${this.share_link_token}`
    },
    renderLimit () {
      return (
        this.previewInfo.category === 'watermark_preview' ||
        !this.permDownload ||
        this.fileItem.is_encrypted
      )
    }
  },
  data () {
    return {
      typeCls: 'type-icon',
      headerExpand: false,
      headerHidden: false,
      loading: true,
      previewInfo: {},
      saved: false,
      shareProcess: {},
      fileItem: {},
      fileItemId: -1,
      isShareRoot: false, // 是否是分享的根目录，如果预览的是分享文件夹中的文件，则不显示底部栏
      isGenerating: true,
      previewCore: PreviewCore,
      share_link_token: '',
      password: '',
      rootId: -1,
      error: false,
      errorMsg: '',
      canSave: false,
      canShare: false,
      percent: 0,
      isOwner: false,
      saveLoading: false,
      viewer: '',
      previewTimer: Object,
      timeStamp: 0
    }
  },
  watch: {
    percent (val) {
      if (val === 100) {
        this.clearStatus()
      }
    }
  },
  methods: {
    toggleHeaderExpand: function () {
      this.headerExpand = !this.headerExpand
    },
    toggleHeaderHidden: function () {
      this.headerHidden = !this.headerHidden
    },
    handlePdfStateChanged: function (state) {
      if (state === PdfState.PSPDFKIT_SUCCEED) {
        this.previewTimer.cancel()
        PreviewLog.succeed(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp))
      } else if (state === PdfState.PSPDFKIT_FAILED) {
        this.previewTimer.cancel()

        // pspdf预览失败后自动切换为pdfjs预览
        this.error = false
        this.previewCore.previewFile({
          type: 'pdf_enc',
          notFirst: true
        })
      } else if (state === PdfState.PDFJS_SUCCEED) {
        PreviewLog.succeed(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp))
        this.previewTimer.cancel()
      } else if (state === PdfState.PDFJS_FAILED) {
        this.previewTimer.cancel()
        PreviewLog.previewError(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp), 'pspdfjs load failed')
      }
    },
    handleWpsStateChanged: function (state) {
      if (state === WpsState.SUCCEED) {
        PreviewLog.succeed(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp))
      } else if (state === WpsState.FAILED) {
        PreviewLog.previewError(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp), 'wps load failed')
      }
    },
    share: function (event) {
      track.click(event)
      WxApi.navigateTo(WxApi.PAGE_SHARE_DETAILS, {
        linkcode: this.share_link_token,
        password: this.password
      })
    },
    save: function (event) {
      track.click(event)
      this.saveLoading = true
      wxajax({
        url: `${SAVE_FILE}`,
        data: {
          item_typed_ids: `file_${this.fileItem.id}`,
          target_folder_id: this.rootId,
          scenario: 'share'
        }
      }).then(res => {
        if (res.success) {
          wxajax({ // 标记当前用户已经保存分享链接
            url: `${APPLET_SAVE_FILE_USER}`,
            data: {
              type: 2, // 2代表保存
              unique_name: this.share_link_token
            }
          })
          // 通知小程序保存成功
          WxApi.postMsg({
            saved: true,
            linkcode: this.share_link_token
          })
          this.saveLoading = false
          if (res.success) {
            this.saved = true
          }
        }
      })
    },
    view: function (event) {
      track.click(event)
      WxApi.switchTab(WxApi.PAGE_MY_DOCUMENT)
    },
    startPreview () {
      this.timeStamp = new Date().getTime()
      BLWxPreview.sum(BLWxPreview.EVENT_PREVIEW, 1)
      this.error = false
      const kind = this.getKind()
      this.openFile(kind)
    },
    getKind () {
      let {
        extension_category,
        extension
      } = this.fileItem

      return this.previewCore.getKind(extension, extension_category)
    },
    openFile (kind) {
      if (kind) {
        this.previewCore.start(kind)
      } else {
        this.isGenerating = false
        this.error = true
        this.errorMsg = this.previewCore.translateErrorMsg('not_support')
      }
    },
    handleVideoError () {
      this.error = true
      this.errorMsg = this.previewCore.translateErrorMsg('media_not_support')
    },
    clearStatus () {
      if (this.generatingStatus || this.isGenerating) {
        setTimeout(() => {
          this.generatingStatus = ''
          this.isGenerating = false
        }, 100)
      }
    },
    handleChangeState (data) {
      if (data.previewInfo) {
        this.previewInfo = data.previewInfo
      }
      if ('error' in data && data.error) {
        this.error = true
        this.isGenerating = false
        if (data.errorMessage) {
          this.errorMsg = data.errorMessage
        } else {
          this.errorMsg = '预览失败'
        }
        const kind = this.getKind()
        if (data.reason && data.reason === 'not_support') {
          BLWxPreview.sum(BLWxPreview.EVENT_NOT_SUPPORT, 1)
          if (PreviewLog.needLog(kind)) {
            PreviewLog.notSupportError(this.fileItem, kind, Math.max(0, new Date().getTime() - this.timeStamp))
          }
        } else {
          BLWxPreview.error(data.errorMessage)
          if (PreviewLog.needLog(kind)) {
            PreviewLog.transformError(this.fileItem.id, Math.max(0, new Date().getTime() - this.timeStamp), data.errorMessage)
          }
        }
      } else {
        if ('percent' in data && data.percent > 0) {
          this.percent = data.percent
        }

        if ('generatingStatus' in data) {
          this.isGenerating = !(data.generatingStatus === 'generated')
        }

        if ('isGenerating' in data) {
          this.isGenerating = data.isGenerating
        }

        if ('viewer' in data) {
          this.viewer = data.viewer
        }

        if (
          data.previewInfo &&
          this.viewer === 'image' &&
          !this.store.imgPreviewInfo.ids.includes(this.fileItem.id)
        ) {
          this.store.imgPreviewInfo.ids.push(this.fileItem.id)
          this.store.imgPreviewInfo.items[this.fileItem.id] = this.fileItem
        }
      }
    }
  },
  created () {
    // 添加qdas脚本
    track.scriptLoader()

    // 添加微信小程序的JS脚本
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute(
      'src',
      'https://res.wx.qq.com/open/js/jweixin-1.4.0.js'
    )
    document.head.appendChild(recaptchaScript)

    this.previewTimer = PreviewTimer.createTimer()

    // 获取url参数
    this.rootId = parseInt(this.$route.query.root_id)
    this.share_link_token = this.$route.params.unique_name
    this.password = this.$route.query.password
    this.saved = this.$route.query.saved !== 'false'
    if (this.$route.query.hasOwnProperty('item_id')) {
      this.fileItemId = parseInt(this.$route.query.item_id)
    } else {
      this.fileItemId = -1
    }
    this.loading = true
    wxajax({
      url: `${GET_SHARE_LINK}/${this.share_link_token}`,
      data: this.password ? { password: this.password } : undefined
    }).then(result => {
      if (result && result.success) {
        this.shareProcess = result.process
        this.canShare = !this.shareProcess.share_link.disable_forward
        this.canSave = !this.shareProcess.share_link.disable_download
        this.isOwner =
          config.user_info.id.toString() ===
          this.shareProcess.share_link.owner.id.toString()

        // 分享的文件就是当前要预览的文件
        if (
          this.fileItemId === -1 ||
            this.fileItemId === result.process.share_link.item.id
        ) {
          this.isShareRoot = true
          this.fileItem = result.process.share_link.item
          this.fileItemId = this.fileItem.id
          normalizeFile(this.fileItem)
          this.loading = false

          this.previewCore = new PreviewCore({
            item: this.fileItem,
            stateChangedCallback: this.handleChangeState,
            scenario: 'share'
          })

          let kind = this.getKind()
          if (kind === 'pdf') { // 暂时只统计pdf
            this.previewTimer.start().then(canceled => {
              if (!canceled) {
                BLWxPreview.error('preview timeout!')
              }
            })
          }
          this.startPreview()
        } else {
          // 分享的是文件夹，要预览的是其中的文件
          this.isShareRoot = false
          wxajax({
            url: `${FILE_INFO}?item_typed_id=file_${this.fileItemId}&scenario=share`
          }).then(res => {
            if (res.success) {
              this.fileItem = res.item
              normalizeFile(this.fileItem)
              this.loading = false

              this.previewCore = new PreviewCore({
                item: this.fileItem,
                stateChangedCallback: this.handleChangeState,
                scenario: 'share'
              })

              let kind = this.getKind()
              if (kind === 'pdf') { // 暂时只统计pdf
                this.previewTimer.start().then(canceled => {
                  if (!canceled) {
                    BLWxPreview.error('preview timeout!')
                  }
                })
              }
              this.startPreview()
            }
          })
        }
      }
    })
  },
  beforeDestroy () {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer)
    }
  }
}
</script>

<style lang="postcss" scoped>
  @import 'layout';
  .main {
    position: relative;
    background-color: #eeeff5;
    &>.preview-error {
      position: absolute;
      width: 100%;
      height: 100%;
      margin-top: 60px;
      padding-bottom: 60px;
      left: 0px;
      top: 0px;
      z-index: 1;
      background-color: #ffffff;
      box-sizing: border-box;
      & .error-icon {
        width: 80px;
        height: 80px;
      }
      & .error-text {
        font-family: PingFangSC;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #999999;
      }
    }
    &>.preview-generating {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0px;
      top: 0px;
      z-index: 1;
      background-color: #ffffff;
      box-sizing: border-box;
    }
    &>.wx-share-file-header {
      position: absolute;
      left: 0px;
      top: 0px;
      z-index: 4;
      background-color: #ffffff;
      & .wx-share-file-header-content {
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 14px;
        padding-bottom: 14px;
        box-sizing: border-box;
      }
      & .item-img-small {
        width: 17px;
        height: 20px;
        margin-right: 8px;
      }
      & .item-name {
        margin-right: 15px;
        font-family: PingFangSC;
        font-size: 17px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        min-width: 0;
        color: #333333;
      }
      & .item-name-small {
        margin-right: 8px;
        font-family: PingFangSC;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        min-width: 0;
        color: #333333;
      }
      & .item-desc {
        margin-right: 15px;
        font-family: PingFangSC;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #999999;
      }
      & .item-img-big {
        width: 31px;
        height: 36px;
        margin-right: 15px;
      }
      & .svg-img {
        width: 14px;
        height: 14px;
        margin-right: 16px;
      }
      & .text-report {
        font-family: PingFangSC;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #6ca2ff;
      }
      & .share-msg {
        font-family: PingFangSC;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.42;
        letter-spacing: -0.3px;
        color: #333333;
      }
    }
    &>.overlay {
      position: absolute;
      left: 0px;
      top: 0px;
      z-index: 3;
      filter: alpha(opacity=60);
      background-color: #777;
      opacity: 0.5;
      -moz-opacity: 0.5;
    }
    &>.preview-main {
      left: 0px;
      top: 0px;
      position: absolute;
      z-index: 0;
      width: 100%;
      height: 100%;
      background-color: #777;

      & .video-container {
        margin-top: 50px;
        margin-left: 16px;
        margin-right: 16px;
        height: 300px;
        background-color: #000000;
      }

      & .yqx-container {
        height: 100%;
        padding-top: 50px;
        padding-bottom: 50px;
        box-sizing: border-box;
      }

      & .pdf-js {
        height: 100%;
        overflow: auto;
      }
    }
    &>.preview-footer {
      position: absolute;
      bottom: 0;
      height: 51px;
      z-index: 2;
      background-color: #fcfcfc;
      & .preview-footer-content {
        height: 50px;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 14px;
        padding-bottom: 14px;
        box-sizing: border-box;
      }
      & .footer-text {
        height: 20px;
        font-family: PingFangSC;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #333333;
        margin-right: 4px;
      }
      & .btn-view {
        height: 20px;
        font-family: PingFangSC;
        font-size: 14px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #6ca2ff;
      }
      & .btn-save {
        width: 66px;
        height: 32px;
        font-family: PingFangSC;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #333333;
        background-color: #ffffff;
      }
      & .btn-share {
        width: 66px;
        height: 32px;
        font-family: PingFangSC;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        background-color: #6ca2ff;
        margin-left: 8px;
      }
    }
  }
  .gap-line {
    height: 1px;
    width: 100%;
    background-color: #eeeeee;
  }
  .share-header-enter-active,
  .share-header-leave-active {
    transition: all 0.2s;
  }
  .share-header-enter,
  .share-header-leave-to {
    transform: translateY(-60px);
  }
  .share-footer-enter-active,
  .share-footer-leave-active {
    transition: all 0.2s;
  }
  .share-footer-enter,
  .share-footer-leave-to {
    transform: translateY(60px);
  }
</style>
